var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1101 -608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48,4A44.013,44.013,0,0,0,30.874,88.544,44.012,44.012,0,0,0,65.126,7.456,43.721,43.721,0,0,0,48,4m0-4A48,48,0,1,1,0,48,48,48,0,0,1,48,0Z",
    transform: "translate(1101 608)",
    fill: "#734bd1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(810.296 -608.841) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.007,6H0A6,6,0,0,1-6,0,6,6,0,0,1,0-6H57.007a6,6,0,0,1,6,6A6,6,0,0,1,57.007,6Z",
    transform: "translate(1106.5 656.004)",
    fill: "#734bd1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.007,6H0A6,6,0,0,1-6,0,6,6,0,0,1,0-6H57.007a6,6,0,0,1,6,6A6,6,0,0,1,57.007,6Z",
    transform: "translate(1135.004 627.5) rotate(90)",
    fill: "#734bd1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.65b5311473be2aff059b211b4befa2a1.svg";
export { ForwardRef as ReactComponent };